import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const getAllRetailers = async (token,params = {}) => {
    const url = `${BASE_URL}/accounts/admin/retailers/`; 
    // console.log(token);
    
  
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
      params
    };
  
    try {
      const response = await axios.get(url, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };

  export const addRetailer = async (token,data) => {
    const url = `${BASE_URL}/accounts/admin/retailers/`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    try {
      const response = await axios.post(url, data,config);
      console.log('response....',response);
      
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Validation or Client Error:", error.response);
        return error.response;
      } else {
        console.log("Error during registration:", error);
      }
    }
  };

  export const deleteRetailer = async (token, retailerID) => {
    const url = `${BASE_URL}/accounts/admin/retailers/${retailerID}/`;
  
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
  
    try {
      const response = await axios.delete(url, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };

  export const updateRetailer = async (token, data, retailerID) => {
    const url = `${BASE_URL}/accounts/admin/retailers/${retailerID}/`;
  
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === "image" && data[key] instanceof File && data[key] !== null) {
        formData.append(key, data[key], data[key].name);
      } else {
        formData.append(key, data[key]);
      }
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
  
    try {
      const response = await axios.patch(url, formData, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Validation or Client Error:", error.response);
        return error.response;
      } else {
        console.error(error);
        throw error;
      }
    }
  };

  export const getRetailer = async (token, retailerID) => {
    const url = `${BASE_URL}/accounts/admin/retailers/${retailerID}/`;
  
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
  
    try {
      const response = await axios.get(url, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };


